import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EntregaZERealizadaDTO;
import { columnas } from "./columns";
const resource = resources.EntregaZERealizada;
export class EntregaZERealizadaList extends React.PureComponent {

    onVer = async (x: Entity) => {
        history.go(`./${x.IdRegistro}`);
    }

    permisos = () => resources.User.PermisoRx;
    columnas = createSelectorRx(this.permisos, permisos => columnas(this, permisos));

    items = observeResource(resource.Query, {});
    onRegresar = () => history.go('../');

    render() {
        const cols = this.columnas(this);

        return (
            <div>
                <kea.Title titulo="Entregas realizadas" onRegresar={this.onRegresar}>
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"EntregaZERealizadaListCookieKey"} items={this.items} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregasZERealizadas/list/list.tsx